import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BoardAncestorsDropdown } from "~/components/Workspace/BoardHeader/BoardCrumbs/BoardAncestorsDropdown";
export const ShortBoardCrumbs = (param)=>{
    let { onBoardClick, ancestors, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-1",
        children: [
            ancestors.length ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BoardAncestorsDropdown, {
                        ancestors: ancestors,
                        onBoardClick: onBoardClick
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-12 text-grey-8",
                        children: "/"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1 truncate px-1 text-12 font-medium text-grey-11",
                children: title
            })
        ]
    });
};
